module.exports = __webpack_public_path__ + "static/media/carp_mobile_geolocalisationn.fc30865d.jpg";